import { createContext } from 'react'

const IndexedDbContext = createContext(null)

export default IndexedDbContext
